import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useState } from 'react';
import { CheckIcon } from './CheckIcon';
import styles from "./ExploreChip.module.css";



const ExploreChip = (props) => {

  const { searchFor, setSearchFor, topicData, setTopicData, topicCheckboxData } = props;

  const [selectedCourseType, setSelectedCourseType] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCourseTypeClick = (index) => {
    setSelectedCourseType(index === selectedCourseType ? null : index);
    console.log(courseType[index]);
    let selectedItem = courseType[index]?.label;
    selectedItem = selectedItem.toLowerCase();

    // Create a shallow copy of the array
    const updatedArray = topicData.map(single => {
      return { ...single, checked: false };
    })

    setTopicData(updatedArray);

    setSearchFor(selectedItem);
  };

  const handleCategoryClick = (index, item) => {

    // Create a shallow copy of the array
    const updatedArray = topicData.map(single => {

      // clicked item → toggle
      if (single.id === item.id) {
        return { ...single, checked: !single.checked };
      }

      // all others → false
      return { ...single, checked: false };
    })

    setSearchFor('courses')
    setTopicData(updatedArray);

  };

  const courseType = [
    {
      label: "All",
      checked: true,
    },
    {
      label: "Courses",
      checked: true,
    },
    {
      label: "Diploma",
      checked: false,
    },
    {
      label: "Certificate",
      checked: false,
    },
  ];



  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>

      <div className={styles.TabContainer}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          {courseType.map((item, index) => (
            <Tab
              onClick={() => handleCourseTypeClick(index)}
              label={<div><CheckIcon /> {item.label}</div>}
              key={`courseType-${index}`}
            />
          ))}

          {topicData.map((item, index) => (
            <Tab
              onClick={() => handleCategoryClick(index, item)}
              // label={
              //   <div><CheckIcon /> {item.label} <div className={styles.TabSubText}>100+ Learners</div> </div>
              // }
              label={
                <div><CheckIcon /> {item.label}</div>
              }
              key={`category-${index}`}
            />
          ))}

        </Tabs>
      </div>


      {/* <div className={styles.chipContainer}> */}
      {/* {courseType.map((item, index) => (
          <Chip
            key={`courseType-${index}`}
            label={item.label}
            sx={{ mb: 1 }}
            icon={selectedCourseType === index ? <DoneRoundedIcon color="#000000" /> : ""}
            variant={selectedCourseType === index ? "filled" : "outlined"}
            onClick={() => handleCourseTypeClick(index)}
          />
        ))} */}
      {/* </div> */}
      {/* <Divider
        orientation="vertical"
        flexItem
        sx={{ margin: 'auto 5px', marginTop: '10px', width: "1px", height: "13px", background: "#00DBFF" }}
      /> */}
      {/* {topicData && 
        <div className={styles.chipContainer}> */}
      {/* {topicData.map((item, index) => (
          <Chip
            key={`category-${index}`}
            label={item.label}
            sx={{ mb: 1 }}
            icon={item.checked ? <DoneRoundedIcon color="#000000" /> : ""}
            variant={item.checked ? "filled" : "outlined"}
            onClick={() => handleCategoryClick(index, item)}
          />
        ))} */}


      {/* </div>} */}

    </>
  );
};

export default ExploreChip;
